/**
 * MainMenu sections by name
 */
export enum MainMenuSection {
    Artists = 'artists',
    CustomTab = 'customTab',
    Events = 'events',
    Language = 'lang',
    Locations = 'locations',
    Profile = 'profile',
}

/**
 * Menu item actions type
 */
export enum MenuItemAction {
    A2HS = 'A2HS'
}